import React from 'react';
import PropTypes from 'prop-types';
import Formsy from 'formsy-react';
import history from 'utils/history';

import { Tabs, TabsContent, TabsList, TabsTrigger, Col, Row, FormGroup, Label, Button, SheetFooter, SheetBody } from 'twyne-new.ui'
import Input from 'components/form/Input';
import SelectTimeZone from 'components/form/SelectTimeZone';
import Switch from 'components/form/Switch';
import Select from 'components/form/Select';
import Checkbox from 'components/form/Checkbox';
import { getCountryOptions } from '@/components/rules/options';

class OrganizationForm extends React.Component {
  state = {
    path: true,
    report: true    
  };

  componentWillMount() {
    const data = this.props.data;
    if (data) {
      this.setState(data);
    }
  }

  handleValidSubmit = (model) => {
    this.props.handleSubmit(Object.assign(this.state, model));
  }

  render() {
    return (
      <Formsy onValidSubmit={this.handleValidSubmit}>
        <SheetBody>
          <Tabs defaultValue='organization' forceMount>
            <TabsList>
              <TabsTrigger className='pt-0' value='organization'>Organization</TabsTrigger>
              <TabsTrigger className='pt-0' value='permissions'>Permissions</TabsTrigger>
            </TabsList>
            <TabsContent value='organization'>
              <Row>
                <Col size="6">
                  <FormGroup>
                    <Label>Organization Name</Label>
                    <Input name="name" value={this.state.name || ''} required />
                  </FormGroup>
                </Col>
                <Col size="6">
                  <FormGroup>
                    <Label>Contact Name</Label>
                    <Input name="contactName" value={this.state.contactName || ''} required />
                  </FormGroup>
                </Col>
                <Col size="6">
                  <FormGroup>
                    <Label>Email</Label>
                    <Input name="email" value={this.state.email || ''} validations="isEmail" validationError="You have to type a valid email" required />
                  </FormGroup>
                </Col>
                <Col size="6">
                  <FormGroup>
                    <Label>Phone</Label>
                    <Input name="phone" value={this.state.phone || ''} />
                  </FormGroup>
                </Col>
                <Col size="6">
                  <FormGroup>
                    <Label>Address</Label>
                    <Input name="address1" value={this.state.address1 || ''} />
                  </FormGroup>
                </Col>
                <Col size="6">
                  <FormGroup>
                    <Label>Address 2</Label>
                    <Input name="address2" value={this.state.address2 || ''} />
                  </FormGroup>
                </Col>

                <Col size="6">
                  <FormGroup>
                    <Label>City</Label>
                    <Input name="city" value={this.state.city || ''} />
                  </FormGroup>
                </Col>
                <Col size="6">
                  <FormGroup>
                    <Label>State</Label>
                    <Input name="state" value={this.state.state || ''} />
                  </FormGroup>
                </Col>
                <Col size="6">
                  <FormGroup>
                    <Label>Zip</Label>
                    <Input name="zip" value={this.state.zip || ''} />
                  </FormGroup>
                </Col>
                <Col size="6">
                  <FormGroup>
                    <Label>Country</Label>
                    <Select
                      value={this.state.country}
                      name="country"
                      options={getCountryOptions()}
                    />
                  </FormGroup>
                </Col>
                <Col size="6">
                  <FormGroup>
                    <Label>Organization URL</Label>
                    <Input name="url" value={this.state.url || ''} placeholder="Ex: http://www.domain.com" />
                  </FormGroup>
                </Col>
                <Col size="6">
                  <FormGroup>
                    <Label>Time Zone</Label>
                    <SelectTimeZone name="timeZone" value={this.state.timeZone} required />
                  </FormGroup>
                </Col>
                <Col size="6">
                  <FormGroup>
                    <Label>Active</Label>
                    <Switch name="active" value={this.state.active || false} />
                  </FormGroup>
                </Col>
              </Row>
            </TabsContent>
            <TabsContent value='permissions'>
              <Row>
                <Col size="4">
                  <Checkbox name="path" value={this.state.path || false} title="Path" />
                </Col>
                <Col size="4">
                  <Checkbox name="report" value={this.state.report || false} title="Reports" />
                </Col>
                <Col size="4">
                  <Checkbox name="cms" value={this.state.cms || false} title="CMS" />
                </Col>
                <Col size="4">
                  <Checkbox name="offer" value={this.state.offer || false} title="Offer" />
                </Col>
                <Col size="4">
                  <Checkbox name="form" value={this.state.form || false} title="Form" />
                </Col>
                <Col size="4">
                  <Checkbox name="setting" value={this.state.setting || false} title="Settings" />
                </Col>
              </Row>
            </TabsContent>
          </Tabs>
        </SheetBody>
        <SheetFooter>
          <Button onClick={() => history.goBack()} variant='ghost'>Cancel</Button>
          <Button type="submit" color='accent'>Save</Button>
        </SheetFooter>
      </Formsy>
    );
  }
}

OrganizationForm.propTypes = {
  handleSubmit: PropTypes.func,
  data: PropTypes.any
};

export default OrganizationForm;
